import { createContext, useContext } from "react";

export const THEME_STORAGE_KEY = "zeus-bpm-theme";

export const THEMES = ["light", "dark", "system"] as const;
export type Theme = (typeof THEMES)[number];

export type ThemeContextValue = {
  readonly theme: Theme;
  readonly setTheme: (_theme: Theme) => void;
};

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useTheme(): ThemeContextValue {
  const value = useContext(ThemeContext);
  if (value === null) {
    throw new Error("useTheme は ThemeProvider の配下で使用してください");
  }
  return value;
}

export function isTheme(value: unknown): value is Theme {
  return (
    typeof value === "string" && (THEMES as readonly string[]).includes(value)
  );
}

/** system の場合は OS 設定を解決して dark かどうかを返す。 */
export function resolveIsDark(theme: Theme, prefersDark: boolean): boolean {
  return theme === "dark" || (theme === "system" && prefersDark);
}
